module.exports = __webpack_public_path__ + "static/media/1 40 selvsagt.69a9af39.mp3";